﻿import { CommentsEditor } from "@/Default/Comments/CommentsEditor";
import { DocumentLinkGrid } from "@/Default/DocumentLink/DocumentLinkGrid";
import { DocumentMailGrid } from "@/Default/Documents/DocumentMailGrid";
import { DocumentTaskGrid } from "@/Default/Documents/DocumentTaskGrid";
import { LookupEditor, IntegerEditor, ImageUploadEditor, StringEditor, DateEditor, Widget, PrefixedContext, initFormType } from "@serenity-is/corelib";

export interface DocumentsForm {
    StatusId: LookupEditor;
    TypeId: LookupEditor;
    OperationId: IntegerEditor;
    TaskId: IntegerEditor;
    MeetingId: IntegerEditor;
    TemplateId: LookupEditor;
    File: ImageUploadEditor;
    Filename: StringEditor;
    Description: StringEditor;
    ReleaseDate: DateEditor;
    RevisionInfo: StringEditor;
    Folder: Widget;
    ProjectId: LookupEditor;
    WBSElementId: LookupEditor;
    BusinessUnitId: LookupEditor;
    ContactUnitId: LookupEditor;
    UsageTypeId: LookupEditor;
    TasksGrid: DocumentTaskGrid;
    DocumentLinkGrid: DocumentLinkGrid;
    MailGrid: DocumentMailGrid;
    CommentsList: CommentsEditor;
    CreatedOn: DateEditor;
    CreatedBy: StringEditor;
    ModifiedOn: DateEditor;
    ModifiedBy: StringEditor;
    OlderVersions: Widget;
}

export class DocumentsForm extends PrefixedContext {
    static readonly formKey = 'Default.Documents';
    private static init: boolean;

    constructor(prefix: string) {
        super(prefix);

        if (!DocumentsForm.init)  {
            DocumentsForm.init = true;

            var w0 = LookupEditor;
            var w1 = IntegerEditor;
            var w2 = ImageUploadEditor;
            var w3 = StringEditor;
            var w4 = DateEditor;
            var w5 = Widget;
            var w6 = DocumentTaskGrid;
            var w7 = DocumentLinkGrid;
            var w8 = DocumentMailGrid;
            var w9 = CommentsEditor;

            initFormType(DocumentsForm, [
                'StatusId', w0,
                'TypeId', w0,
                'OperationId', w1,
                'TaskId', w1,
                'MeetingId', w1,
                'TemplateId', w0,
                'File', w2,
                'Filename', w3,
                'Description', w3,
                'ReleaseDate', w4,
                'RevisionInfo', w3,
                'Folder', w5,
                'ProjectId', w0,
                'WBSElementId', w0,
                'BusinessUnitId', w0,
                'ContactUnitId', w0,
                'UsageTypeId', w0,
                'TasksGrid', w6,
                'DocumentLinkGrid', w7,
                'MailGrid', w8,
                'CommentsList', w9,
                'CreatedOn', w4,
                'CreatedBy', w3,
                'ModifiedOn', w4,
                'ModifiedBy', w3,
                'OlderVersions', w5
            ]);
        }
    }
}